import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { changeField } from '../store/actions/form';
import { getImportRequest } from '../store/selectors';
import { runImport } from '../store/actions/importer';
import { setImportStatusType } from '../store/actions/importer';

export function ReadyToImportModal({
  importRequest,
  setImportStatusType,
  shown,
  onClose,
  onChange,
  onRunImport
}) {
  const history = useHistory();

  const onCancel = () => {
    onClose(false);
  };

  const handleFormSubmit = () => {
    onRunImport()
      .then((response) => {
        if (response) {
          history.push(`/${importRequest.id}/run`);
          setImportStatusType('run');
        }
      });
  };

  const handleCheckboxChange = () => {
    onChange('emailNotification', !importRequest.emailNotification);
  };

  return (
    <Modal show={shown} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Ready to import?</Modal.Title>
      </Modal.Header>
      <Modal.Body className="left-buffer-md">
        <div className="top-buffer-sm mb-4" name="sentToSupportMessage">
          <p>
            The final step is to run your import.
            This step might take a while, so we recommend you get notified by email once it is complete.    
          </p>
          <p>
            Once you start your import, you will not be able to go back in this process to modify or abort it.
            Are you ready to run this import?    
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <label className="email-notification-checkbox">
          <input checked={importRequest.emailNotification}
            name="emailNotification"
            type="checkbox"
            onChange={handleCheckboxChange}
          />
          <span>Notify me by email when verification is complete</span>
        </label>
        <div className="btn btn-sm btn-cancel" onClick={onCancel}>Close</div>
        <div className="btn btn-sm btn-save" onClick={handleFormSubmit}>Run import</div>
      </Modal.Footer>
    </Modal>
  );
}

ReadyToImportModal.propTypes = {
  importRequest: PropTypes.object.isRequired,
  setImportStatusType: PropTypes.func.isRequired,
  shown: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onRunImport: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  importRequest: getImportRequest(state)
});

const mapDispatchToProps = {
  setImportStatusType,
  onRunImport: runImport,
  onChange: changeField
};

export default connect(mapStateToProps, mapDispatchToProps)(ReadyToImportModal);
